import {
  subclass,
  property
} from "@arcgis/core/core/accessorSupport/decorators";

import esriRequest from "@arcgis/core/request";

import EsriPortalUser from "@arcgis/core/portal/PortalUser";
import Role from "./Role";

interface PortalUser extends EsriPortalUser {}

@subclass("esri.portal.PortalUser")
class PortalUser extends EsriPortalUser {
  public isOrgUser: boolean = false;
  public isOrgAdmin: boolean = false;
  public isViewOnly: boolean = false;

  public canCreateItems: boolean = false;
  public canShare: boolean = false;
  public canShareOthers: boolean = false;

  public userRole: any;
  public hasSubscriberContent: any = null;

  constructor(params?: any) {
    super(params);
  }

  init() {
    const userRole = (this.userRole = this.setRole());
    const { portal } = this;
    this.isOrgUser =
      (portal.urlKey && portal.customBaseUrl) || portal.isPortal ? true : false;
    this.isOrgAdmin = userRole.isAdmin();

    // can user create items set it here since we use this everywhere
    this.canCreateItems = !this.isOrgUser || userRole.canCreateItem();

    // can user share items
    // public users and org members with sharing privileges can share
    this.canShare =
      !this.isOrgUser ||
      userRole.canShareItemToGroup() ||
      userRole.canShareItemToOrg() ||
      (portal.canSharePublic && userRole.canShareItemToPublic());

    // can user share others items
    this.canShareOthers =
      userRole.canShareOthersItemsToGroup() ||
      userRole.canShareOthersItemsToOrg() ||
      (portal.canSharePublic && userRole.canShareOthersItemsToPublic());
  }

  setRole(): Role {
    // setup user role
    this.userRole = new Role({
      portalUser: this
    });
    return this.userRole;
  }

  public hasSubscriptionContent(): Promise<any> {
    const method = "get";
    const query = { f: "json", num: 1 };
    const responseType = "json";
    const reqOpts = {
      callbackParamName: "callback",
      method,
      query,
      responseType
    };
    const { hasSubscriberContent, portal } = this;
    const url = `${portal.restUrl}/community/users/${this.username}/provisionedListings`;
    return new Promise((resolve, reject) => {
      if (hasSubscriberContent !== null) {
        resolve(hasSubscriberContent);
      } else {
        esriRequest(url, reqOpts as any).then(response => {
          const data = (response && response.data) || {};
          const hasSubscriberContent = (this.hasSubscriberContent =
            data.total > 0);
          resolve(hasSubscriberContent);
        });
      }
    });
  }
}

export default PortalUser;
